import React from "react";

import classes from "./css/ImageOnGridArchive.module.css";

const ImageOnGridArchive = (props) => {
  return (
    <button
      className={classes.main_image_archive}
      onClick={props.onClick}
      key={props.id}
    >
      <div className={classes.info_archive_card}>
        <h1>{props.year}</h1>
        <h2>{props.title}</h2>
      </div>

      <div
        className={classes.image_archive}
        style={{ backgroundImage: `url(${props.image})` }}
      />
    </button>
  );
};

export default ImageOnGridArchive;
